import type { ModuleManifest } from "./types";

export const auditManifest: ModuleManifest = {
  name: "audit",
  label: "Audit",
  labelPlural: "Audit",
  coreBOSModule: "Audit",
  wsidPrefix: "82x",
  type: "standard",
  routes: {
    list: "/audit",
    show: "/audit/show/:id",
    create: "/audit/create",
    edit: "/audit/edit/:id",
  },
  navigation: {
    icon: "AuditOutlined",
    order: 2,
    group: "Compliance",
  },
  routing: {
    keywords: ["audit", "verifica", "snapshot", "compliance"],
    searchFields: ["auditname"],
    defaultSort: { field: "auditname", order: "desc" },
  },
  context: { supported: true, entityKey: "audit" },
  fields: [
    { name: "auditname", label: "Nome Audit", type: "string", required: true },
    { name: "audit_status", label: "Stato", type: "picklist", options: [
      { value: "Planned", label: "Pianificato" },
      { value: "In_Progress", label: "In corso" },
      { value: "Completed", label: "Completato" },
      { value: "Failed", label: "Non superato" },
    ]},
    { name: "startdate", label: "Data Inizio", type: "date" },
    { name: "enddate", label: "Data Fine", type: "date" },
    { name: "organization_id", label: "Account", type: "reference" },
    { name: "description", label: "Descrizione", type: "text" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    { module: "Accounts", field: "organization_id", label: "Account", icon: "BankOutlined", displayField: "accountname" },
    { module: "Documents", relation: "many-to-many", label: "Documenti", icon: "AppstoreOutlined", displayField: "notes_title" },
  ],
  requiredFields: ["auditname"],
  viewStrategy: "bespoke",
};
